
    /**
	 * @description
	 *	Modelo de usuario utilizado al devolver el resultado de una búsqueda.
	 *
	 * @see gigot-backend/ViewModels/ApplicationUser/UserFindDTO.cs
	 */

export class UserFind {

    public documentNumber: string;
    public email: string;
    public firstName: string;
    public id: string;
    public inactiveCampaigns: number;
    public lastName: string;
    public locality: string;
    public orderStatus: number;
    public phoneNumber: string;
    public profileStatusType: string;
    public resellerStatus: string;
    public roles: string[];
    public userName: string;
    public userStatus: string;

    /**
     * @description
     *  Construye un usuario, resultado de alguna búsqueda, con una semántica
     *  vacía. Nótese que no es lo mismo que construir un usuario con valores
     *  por defecto. Las reglas generales de construcción son:
     *
     *      - Campos 'array' se definen como [].
     *      - Campos 'boolean' se definen como 'false'.
     *      - Campos 'Date' se definen como 'undefined'.
     *      - Campos 'enum' se definen como 'undefined'.
     *      - Campos 'number' se definen como 'undefined'.
     *      - Campos 'string' se definen como '' (cadena vacía).
     *      - Campos 'object' se definen llamando a su propio método #empty().
     *      - Campos de la superclase se definen al igual que campos 'object'.
     *      - Campos genéricos se definen como 'undefined'.
	 *		- Campos recursivos se definen como 'undefined'.
     *
     * @returns
     *	Un usuario (resultado de alguna búsqueda), vacío.
     */
    public static empty(): UserFind {
        const userFind: UserFind = new UserFind();
        userFind.documentNumber = "";
        userFind.email = "";
        userFind.firstName = "";
        userFind.id = "";
        userFind.inactiveCampaigns = undefined;
        userFind.lastName = "";
        userFind.locality = "";
        userFind.orderStatus = undefined;
        userFind.phoneNumber = "";
        userFind.profileStatusType = "";
        userFind.resellerStatus = "";
        userFind.roles = [];
        userFind.userName = "";
        userFind.userStatus = "";
        return userFind;
    }
}
